import Budget from './Budget.container';

export default Budget;